export const rules = {
    Title: {
        presence: { allowEmpty: false },
    },
    ButtonText: {
        presence: { allowEmpty: false },
    }
}